import { VALIDATE_PARTNO, RETURNS_PARTNO_LIST, NO_RETURNS_NEEDED_CB, RETURNS } from '../actions/actionTypes';

const initialState = {
    items_returnsState: [0],
    noReturnsNeededCbState: false,
    // items_returnsPartnoList: [{value:'FVPP24FEFB',label:'FVPP24FEFB'},{value:'FVPP35EFB',label:'FVPP35EFB'},{value:'FVPP51REFB',label:'FVPP51REFB'}],
    items_returnsPartnoList: [],
    partnoIsValid: false,

}

const returnsReducer = (state = initialState, action) => {
    switch(action.type){ 
        case RETURNS:
            return {
                ...state,
                items_returnsState: action.payload,
            }      
        case NO_RETURNS_NEEDED_CB:
            return {
                ...state,
                noReturnsNeededCbState: action.payload
            }   
        case RETURNS_PARTNO_LIST:
            return {
                ...state,
                items_returnsPartnoList: action.payload
            }
        case VALIDATE_PARTNO:
            return {
                ...state,
                items_returnsPartnoList: [...state.items_returnsPartnoList, {'value':action.payload, 'label': action.payload}],
                partnoIsValid: action.payload
            }            
        default:
            return state;
    }
}

export { returnsReducer };